import { Icon, Modal, TextField, FormLayout } from '@shopify/polaris';
import { ImageIcon } from '@shopify/polaris-icons';
import { useState } from 'react';

export const ImageButton = ({ onFocus, disabled }: { onFocus: () => void; disabled?: boolean }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const [imageUrlError, setImageUrlError] = useState('');
  const [savedRange, setSavedRange] = useState<Range | null>(null);

  const [width, setWidth] = useState('');
  const [height, setHeight] = useState('');

  const handleImageInsert = () => {
    if (imageUrl) {
      const img = document.createElement('img');
      img.src = imageUrl;
      if (width) img.width = parseInt(width);
      if (height) img.height = parseInt(height);

      if (savedRange) {
        const selection = window.getSelection();
        selection?.removeAllRanges();
        selection?.addRange(savedRange);
      }

      onFocus();
      document.execCommand('insertHTML', false, img.outerHTML);
      handleCloseModal();
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setImageUrl('');
    setWidth('');
    setHeight('');
  };

  const handleOpenModal = () => {
    const selection = window.getSelection();
    if (selection && selection.rangeCount > 0) {
      setSavedRange(selection.getRangeAt(0).cloneRange());
    }
    setIsModalOpen(true);
  };

  const handleChangeImageUrl = (value: string) => {
    setImageUrl(value);
    if (value) setImageUrlError('');
    else setImageUrlError('This field is required');
  };

  return (
    <>
      <button
        onClick={handleOpenModal}
        style={{
          padding: '4px 8px',
          backgroundColor: '#fff',
          border: '1px solid #ccc',
          borderRadius: '4px',
          cursor: 'pointer',
        }}
        title="Insert Image"
        disabled={disabled}
      >
        <Icon source={ImageIcon} tone="base" />
      </button>

      <Modal
        open={isModalOpen}
        onClose={handleCloseModal}
        title="Insert Image"
        primaryAction={{
          content: 'Insert',
          onAction: handleImageInsert,
          disabled: !imageUrl,
        }}
        secondaryActions={[
          {
            content: 'Cancel',
            onAction: handleCloseModal,
          },
        ]}
      >
        <Modal.Section>
          <FormLayout>
            <TextField
              label="Image URL"
              value={imageUrl}
              onChange={handleChangeImageUrl}
              autoComplete="off"
              error={imageUrlError}
              requiredIndicator
              onBlur={() => {
                if (!imageUrl) setImageUrlError('This field is required');
              }}
            />
            <div className="d-flex gap-16" id="image-btn-in-editor">
              <div className="w-full">
                <TextField label="Width (px)" type="number" value={width} onChange={setWidth} autoComplete="off" />
              </div>
              <div className="w-full">
                <TextField label="Height (px)" type="number" value={height} onChange={setHeight} autoComplete="off" />
              </div>
            </div>
          </FormLayout>
        </Modal.Section>
      </Modal>
    </>
  );
};
